import { applyMiddleware, createStore, compose } from "redux";
import { thunk } from "redux-thunk";
import rootReducers from "../reducers";

let composeEnhancers = compose;

if (
  process.env.NODE_ENV === "development" &&
  typeof window !== "undefined" &&
  window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
) {
  composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;
}

const enhancers = composeEnhancers(applyMiddleware(thunk));

const store = createStore(rootReducers, enhancers);
export default store;
